export class ApplicationQueueHeader {
  headerId: string;
  name: string;
  sort: string;
  udfType?: string;
  templateLink?: string;
  isEnabled?: boolean;
}
